import { render, staticRenderFns } from "./MonthlyExtrasInput.vue?vue&type=template&id=5d25299a&"
import script from "./MonthlyExtrasInput.vue?vue&type=script&lang=js&"
export * from "./MonthlyExtrasInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports